import React, { useState } from 'react';
import FormField from './FormField';

export default function ResourceForm({
  resource,
  fields,
  onSubmit,
  onCancel,
  loading,
  submitLabel,
  cancelLabel,
  hideHeading,
  children
}) {
  const [formState, setFormState] = useState(() =>
    fields.reduce((acc, f) => ({ ...acc, [f.key]: resource?.[f.key] ?? '' }), {})
  );

  const handleSubmit = (e) => {
    e.preventDefault();
    onSubmit(formState);
  };

  const handleChange = (key, value) => {
    setFormState((prev) => ({ ...prev, [key]: value }));
  };

  const getFieldError = (field) => {
    if (field.error) return field.error(formState);
    return null;
  };

  return (
    <form className="resource-form" onSubmit={handleSubmit}>
      {!hideHeading && (
        <h2>
          {resource?.id ? 'Edit' : 'New'} {resource?.type || 'Item'}
        </h2>
      )}
      {fields.map((field) => (
        <FormField
          key={field.key}
          field={field}
          value={formState[field.key]}
          onChange={(v) => handleChange(field.key, v)}
          error={getFieldError(field)}
        />
      ))}
      {children}
      <div className="form-actions">
        <button type="submit" className="btn btn-primary" disabled={loading}>
          {loading ? 'Saving...' : submitLabel || 'Save'}
        </button>
        <button type="button" className="btn btn-secondary" onClick={onCancel}>
          {cancelLabel || 'Cancel'}
        </button>
      </div>
    </form>
  );
}
